import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=536e30a1&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=536e30a1&prod&lang=scss&scoped=true"
import style1 from "./TheHeader.vue?vue&type=style&index=1&id=536e30a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536e30a1",
  null
  
)

export default component.exports